import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-14ca98c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "warning"
}, "Updating the periods for the strategy will be deleted and recreated with the new periods.", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Do you wish to continue?", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_omny_confirm_continue_modal = _resolveComponent("omny-confirm-continue-modal");
  return _openBlock(), _createBlock(_component_omny_confirm_continue_modal, {
    modelValue: $options.modal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.modal = $event),
    continueVariant: "primary",
    onContinue: _cache[1] || (_cache[1] = $event => _ctx.$emit('update')),
    onCancel: _cache[2] || (_cache[2] = $event => _ctx.$emit('cancel'))
  }, {
    title: _withCtx(() => [_createTextVNode("Update strategy period")]),
    continue: _withCtx(() => [_createTextVNode("Yes, update")]),
    default: _withCtx(() => [_hoisted_1, _hoisted_2, _hoisted_3, _hoisted_4]),
    _: 1
  }, 8, ["modelValue"]);
}